<template>
  <b-container fluid>
    <!-- Existing market session info -->
    <b-row>
      <b-col><b>Market Session:</b> {{ $route.params.sessionId }}</b-col>
      <b-col><b>Market Type:</b> {{ $route.params.marketType }}</b-col>
      <b-col
        ><b>Date Start Activation:</b>
        {{ $route.params.startActivation | formatDate }}</b-col
      >
    </b-row>
    <br />

    <b-tabs content-class="mt-3">
      <b-tab title="Flexibility Services" active>
        <b-card title="OAP">
          <b-table
            striped
            hover
            :items="bspOffers"
            :fields="fieldsBspOffer"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            @filtered="onFiltered"
            class="table-romeflex"
          >
            <template #cell(workflowStatus)="data">
              <b-badge
                v-if="data.item.workflowStatus && data.item.workflowStatus.message"
                  :variant="data.item.workflowStatus.success ? 'success' : 'danger'"
              >
                {{ data.item.workflowStatus.message }}
              </b-badge>
              <span v-else>
                {{ data.item.status || '' }}
              </span>
            </template>
            <template #cell(power)="data">
              <b-button size="sm" @click="data.toggleDetails">
                {{ data.detailsShowing ? "Hide" : "Show" }} Details
              </b-button>
            </template>

            <template #row-details="data">
              <b-card>
                <b-card
                  v-for="(flexItem, index) in data.item.flexibility"
                  :key="index"
                >
                  <b-row>
                    <b-col><b>Service Id :</b> {{ flexItem.serviceId }}</b-col>
                  </b-row>
                  <b-row style="margin-top: 20px">
                    <b-col>
                      <b-table
                        responsive
                        hover
                        bordered
                        outlined
                        small
                        :items="flexItem.power"
                        :fields="fieldsPower"
                        class="tablePower tablePower-hover table-romeflex"
                      >
                        <template #cell(index)="result">
                          {{ result.item.index }}
                        </template>
                        <template #cell(pUp)="result">
                          {{
                            result.item.pUp
                              ? Math.round(result.item.pUp) / 1000
                              : result.item.pUp
                          }}
                        </template>
                        <template #cell(pUpPrice)="result">
                          {{
                            result.item.pUpPrice
                              ? Math.round(result.item.pUpPrice) /
                                100 /
                                0.25 /
                                1000
                              : result.item.pUpPrice
                          }}
                        </template>
                        <template #cell(pDown)="result">
                          {{
                            result.item.pDown
                              ? Math.round(result.item.pDown) / 1000
                              : result.item.pDown
                          }}
                        </template>
                        <template #cell(pDownPrice)="result">
                          {{
                            result.item.pDownPrice
                              ? Math.round(result.item.pDownPrice) /
                                100 /
                                0.25 /
                                1000
                              : result.item.pDownPrice
                          }}
                        </template>
                      </b-table>
                    </b-col>
                  </b-row>
                </b-card>
              </b-card>
            </template>
          </b-table>
          <b-row>
            <b-col md="6" class="my-1">
              <b-pagination
                :total-rows="totalRows"
                :per-page="perPage"
                v-model="currentPage"
                class="my-0"
              />
            </b-col>
          </b-row>
        </b-card>

        <b-card title="Dso Requests">
          <!-- Add new perimeter button -->
          <div class="mb-3" v-if="$route.params.status === 'mip-request'">
            <b-button
              v-if="!dsoRequests.length"
              @click="showNewDsoRequestDialog"
              class="mr-2 blue-class"
            >
              Create New DSO Request
            </b-button>
            <b-button
              v-else
              class="orange-class"
              @click="showAddPerimeterDialog"
            >
              Add New Perimeter
            </b-button>
          </div>

          <b-table
            striped
            hover
            :items="dsoRequests"
            :fields="fieldsDsoRequest"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            @filtered="onFiltered"
            class="table-romeflex"
          >
           <template #cell(workflowStatus)="data">
              <b-badge
                v-if="data.item.workflowStatus && data.item.workflowStatus.message"
                :variant="data.item.workflowStatus.success ? 'success' : 'danger'"
              >
                {{ data.item.workflowStatus.message }}
              </b-badge>
              <span v-else>
                {{ data.item.status || '' }}
              </span>
            </template>
            <template #cell(flexibility)="data">
              <b-button size="sm" @click="data.toggleDetails">
                {{ data.detailsShowing ? "Hide" : "Show" }} Details
              </b-button>
            </template>
            <template #row-details="data">
              <b-list-group>
                <b-list-group-item
                  v-for="result in data.item.flexibility"
                  v-bind:key="result._id"
                >
                  <b-card>
                    <b-row>
                      <b-col sm="8"
                        ><b>Service Id:</b> {{ result.serviceId }}</b-col
                      >
                      <b-col
                        sm="4"
                        class="text-right"
                        v-if="$route.params.status === 'mip-request'"
                      >
                        <b-button
                          v-if="result.isMip"
                          @click="editPerimeter(data.item, result)"
                          class="ml-2 orange-class"
                        >
                          <b-icon icon="pencil-fill"></b-icon> Edit Perimeter
                        </b-button>
                        <b-button
                          v-if="result.isMip"
                          @click="removePerimeterFromRequest(data.item, result)"
                          class="ml-2"
                          variant="danger"
                        >
                          <b-icon icon="trash"></b-icon> Remove Perimeter
                        </b-button>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col><b>Pod Request List:</b></b-col>
                    </b-row>
                    <b-row>
                      <b-col>
                        <b-table
                          responsive
                          hover
                          bordered
                          outlined
                          small
                          :items="result.podRequestList"
                          :fields="fieldsPodRequestList"
                          class="tablePower tablePower-hover table-romeflex"
                        >
                          <template #cell(pod)="result">
                            {{ result.item.pod }}
                          </template>
                          <template #cell(baselineId)="result">
                            {{ result.item.baselineId }}
                          </template>
                        </b-table>
                      </b-col>
                    </b-row>
                  </b-card>
                  <b-card>
                    <b-row>
                      <b-col><b>Power:</b></b-col>
                    </b-row>
                    <b-row>
                      <b-col>
                        <b-table
                          responsive
                          hover
                          bordered
                          outlined
                          small
                          :items="result.power"
                          :fields="fieldsPowerDsoRequest"
                          class="tablePower tablePower-hover table-romeflex"
                        >
                          <template #cell(index)="result">
                            {{ result.item.index }}
                          </template>
                          <template #cell(pUp)="result">
                            {{
                              result.item.pUp
                                ? Math.round(result.item.pUp) / 1000
                                : result.item.pUp
                            }}
                          </template>
                          <template #cell(pUpPrice)="result">
                            {{
                              result.item.pUpPrice
                                ? Math.round(result.item.pUpPrice) /
                                  100 /
                                  0.25 /
                                  1000
                                : result.item.pUpPrice
                            }}
                          </template>
                          <template #cell(pDown)="result">
                            {{
                              result.item.pDown
                                ? Math.round(result.item.pDown) / 1000
                                : result.item.pDown
                            }}
                          </template>
                          <template #cell(pDownPrice)="result">
                            {{
                              result.item.pDownPrice
                                ? Math.round(result.item.pDownPrice) /
                                  100 /
                                  0.25 /
                                  1000
                                : result.item.pDownPrice
                            }}
                          </template>
                        </b-table>
                      </b-col>
                    </b-row>
                  </b-card>
                </b-list-group-item>
              </b-list-group>
            </template>
          </b-table>
          <b-row>
            <b-col md="6" class="my-1">
              <b-pagination
                :total-rows="totalRows"
                :per-page="perPage"
                v-model="currentPage"
                class="my-0"
              />
            </b-col>
          </b-row>

          <!-- New DSO Request Modal -->
          <b-modal
            id="modal-new-dso-request"
            title="Create New DSO Request"
            size="xl"
            @ok.prevent="handleNewDsoRequestSubmit"
            @cancel="resetNewDsoRequestForm"
            @hidden="resetNewDsoRequestForm"
            ok-title="Create"
            :ok-disabled="isSubmitting"
          >
            <dso-request-form
              ref="dsoRequestForm"
              :market-session-id="$route.params.sessionId"
              :market-type="$route.params.marketType"
              :start-activation="$route.params.startActivation"
              :available-pods="availablePods"
              @pod-selected="handlePodSelection"
            />
            <template #modal-footer="{ ok, cancel }">
              <b-button
                variant="primary"
                :disabled="isSubmitting"
                @click="handleNewDsoRequestSubmit"
              >
                <b-spinner small v-if="isSubmitting"></b-spinner>
                {{ isSubmitting ? "Creating..." : "Create" }}
              </b-button>
              <b-button variant="secondary" @click="cancel()">
                Cancel
              </b-button>
            </template>
          </b-modal>

          <!-- Add Perimeter Modal -->
          <b-modal
            id="modal-add-perimeter"
            :title="isEditing ? 'Edit Perimeter' : 'Add New Perimeter'"
            size="xl"
            @ok="handleSavePerimeter"
            @hidden="resetPerimeterForm"
            ok-title="Save"
          >
            <div class="perimeter-form-container">
              <template v-if="!isEditing">
                <b-button @click="addNewPerimeter" class="mb-3 blue-class">
                  Add Perimeter
                </b-button>

                <div
                  v-for="(perimeter, index) in editingPerimeters"
                  :key="index"
                >
                  <b-card no-body class="mb-3">
                    <b-card-header header-tag="header" role="tab">
                      <b-button
                        v-b-toggle="'perimeter-' + index"
                        block
                        class="custom-button d-flex justify-content-between align-items-center"
                      >
                        <span>PERIMETER {{ index + 1 }}</span>
                        <b-icon
                          :icon="visible ? 'chevron-up' : 'chevron-down'"
                        ></b-icon>
                      </b-button>
                    </b-card-header>

                    <b-collapse :id="'perimeter-' + index" visible>
                      <b-card-body>
                        <perimeter-form
                          :ref="'perimeterForm-' + index"
                          :all-selected-pods="allSelectedPods"
                          :market-session-id="$route.params.sessionId"
                          :market-type="marketType"
                          :start-activation="startActivation"
                          :available-pods="getPodsAvailableForPerimeter(index)"
                          :service-id="perimeter.serviceId"
                          :perimeter-index="index"
                          @pods-selected="
                            (pods) => handlePerimeterPodSelection(index, pods)
                          "
                          @pod-permanently-selected="
                            handlePodPermanentSelection
                          "
                          @pod-restored="handlePodRestored"
                          @pod-toggled="handlePodToggle"
                        />
                        <b-button
                          variant="danger"
                          size="sm"
                          @click="removePerimeter(index)"
                          class="mt-2"
                        >
                          Remove Perimeter
                        </b-button>
                      </b-card-body>
                    </b-collapse>
                  </b-card>
                </div>
              </template>

              <template v-else>
                <b-card no-body class="mb-3">
                  <b-card-body>
                    <perimeter-form
                      ref="editForm"
                      :all-selected-pods="allSelectedPods"
                      :market-session-id="$route.params.sessionId"
                      :market-type="marketType"
                      :start-activation="startActivation"
                      :available-pods="getPodsAvailableForPerimeter(0)"
                      :service-id="editingData.perimeter.serviceId"
                      :initial-data="editingData.perimeter"
                      :perimeter-index="0"
                      @pods-selected="
                        (pods) => handlePerimeterPodSelection(0, pods)
                      "
                      @pod-permanently-selected="handlePodPermanentSelection"
                      @pod-restored="handlePodRestored"
                      @pod-toggled="handlePodToggle"
                    />
                  </b-card-body>
                </b-card>
              </template>
            </div>
          </b-modal>
        </b-card>
      </b-tab>

      <b-tab title="Market Outcome">
        <template>
          <b-list-group>
            <b-list-group-item
              v-for="item in marketOutcome"
              v-bind:key="item._id"
            >
              <b-card>
                <b-row>
                  <b-col><b>Market Outcome Id:</b> {{ item._id }}</b-col>
                  <!--   <b-col md="9" offset-md="9">
                          <div class="md-layout-item md-small-size-20 md-size-20 md-alignment-center-right">
                            <b-btn class="xlsx-button" @click="exportToMoExcel(item.flexibility, item.marketType, item.startTime)">Download Market Outcome&nbsp;&nbsp;<b-icon icon="file-earmark-excel"/></b-btn>
                          </div>
                      </b-col> -->
                </b-row>
                <div v-if="item.flexibility && item.flexibility.length > 0">
                  <b-card
                  v-for="flex in item.flexibility"
                  v-bind:key="flex._id"
                  class="flex-card"
                >
                  <b-row>
                    <b-col><b>Pod:</b> {{ flex.pod }}</b-col>
                  </b-row>
                  <b-row>
                    <b-col><b>Merit Order List:</b></b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <b-table
                        responsive
                        hover
                        bordered
                        outlined
                        small
                        :items="flex.meritOrderList"
                        :fields="fieldsMarketOutcome"
                        class="tablePower tablePower-hover table-romeflex"
                      >
                        <template #cell(index)="result">
                          {{ result.item.index }}
                        </template>
                        <template #cell(pUp)="result">
                          {{
                            result.item.pUp
                              ? Math.round(result.item.pUp) / 1000
                              : result.item.pUp
                          }}
                        </template>
                        <template #cell(pDown)="result">
                          {{
                            result.item.pDown
                              ? Math.round(result.item.pDown) / 1000
                              : result.item.pDown
                          }}
                        </template>
                        <template #cell(priorityP)="result">
                          {{ result.item.priorityP }}
                        </template>
                        <template #cell(qUp)="result">
                          {{
                            result.item.qUp
                              ? Math.round(result.item.qUp) / 1000
                              : result.item.qUp
                          }}
                        </template>
                        <template #cell(qDown)="result">
                          {{
                            result.item.qDown
                              ? Math.round(result.item.qDown) / 1000
                              : result.item.qDown
                          }}
                        </template>
                        <template #cell(priorityQ)="result">
                          {{ result.item.priorityQ }}
                        </template>
                      </b-table>
                    </b-col>
                  </b-row>
                  </b-card>
                </div>
                <div v-else>
                  <b-card class="flex-card empty">
                    <b-row>
                      <b-col class="text-muted">
                        ⚠️ No flexibility available (Empty)
                      </b-col>
                    </b-row>
                  </b-card>
                </div>
              </b-card>
            </b-list-group-item>
          </b-list-group>
        </template>
      </b-tab>
      <b-tab title="Technical Outcome">
        <template>
          <b-list-group>
            <b-list-group-item
              v-for="to in technicalOutcome"
              v-bind:key="to._id"
            >
              <b-card>
                <b-row>
                  <b-col><b>Technical Outcome Id:</b> {{ to._id }}</b-col>
                  <b-col>
                    <b>
                      Technical Outcome Sending status:
                      <b-badge v-if="to.workflowStatus && to.workflowStatus.message" :variant="to.workflowStatus.success ? 'success' : 'danger'">
                       {{ to.workflowStatus.message }}
                      </b-badge>
                    </b>
                  </b-col>
                </b-row>
                <b-card
                  v-for="tOutcome in to.flexibility"
                  v-bind:key="tOutcome._id"
                  class="flex-card"
                >
                  <b-row>
                    <b-col><b>Pod:</b> {{ tOutcome.pod }}</b-col>
                  </b-row>
                  <b-row>
                    <b-col><b>Power:</b></b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <b-table
                        responsive
                        hover
                        bordered
                        outlined
                        small
                        :items="tOutcome.power"
                        :fields="fieldsTechinicalOutcome"
                        class="tablePower tablePower-hover table-romeflex"
                      >
                        <template #cell(index)="resultTo">
                          {{ resultTo.item.index }}
                        </template>
                        <template #cell(pUpMax)="resultTo">
                          {{
                            resultTo.item.pUpMax
                              ? Math.round(resultTo.item.pUpMax) / 1000
                              : resultTo.item.pUpMax
                          }}
                        </template>
                        <template #cell(pDownMax)="resultTo">
                          {{
                            resultTo.item.pDownMax
                              ? Math.round(resultTo.item.pDownMax) / 1000
                              : resultTo.item.pDownMax
                          }}
                        </template>
                        <template #cell(qUpMax)="resultTo">
                          {{
                            resultTo.item.qUpMax
                              ? Math.round(resultTo.item.qUpMax) / 1000
                              : resultTo.item.qUpMax
                          }}
                        </template>
                        <template #cell(qDownMax)="resultTo">
                          {{
                            resultTo.item.qDownMax
                              ? Math.round(resultTo.item.qDownMax) / 1000
                              : resultTo.item.qDownMax
                          }}
                        </template>
                      </b-table>
                    </b-col>
                  </b-row>
                </b-card>
              </b-card>
            </b-list-group-item>
          </b-list-group>
        </template>
      </b-tab>
      <b-tab title="Validated Outcome">
        <template>
          <b-list-group>
            <b-list-group-item
              v-for="vo in validatedOutcome"
              v-bind:key="vo._id"
            >
              <b-card>
                <b-row>
                  <b-col><b>Validated Outcome Id:</b> {{ vo._id }}</b-col>
                  <b-col><b>Service Id:</b> {{ vo.serviceId }}</b-col>
                  <!--   <b-col md="9" offset-md="9">
                          <div class="md-layout-item md-small-size-20 md-size-20 md-alignment-center-right">
                            <b-btn class="xlsx-button" @click="exportToVoExcel(vo.flexibility, vo.marketType, vo.startTime)">Download Validate Outcome&nbsp;&nbsp;<b-icon icon="file-earmark-excel"/></b-btn>
                          </div>
                      </b-col>-->
                </b-row>
                <b-row>
                  <b-col><b>BSP Id:</b> {{ vo.bspId }}</b-col>
                  <b-col><b>Product Code:</b> {{ vo.productCode }}</b-col>
                </b-row>

                <b-card class="flex-card">
                  <b-row>
                    <b-col><b>Pod:</b> {{ vo.pod }}</b-col>
                  </b-row>
                  <b-row>
                    <b-col><b>Power:</b></b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <b-table
                        responsive
                        hover
                        bordered
                        outlined
                        small
                        :items="vo.power"
                        :fields="fieldsValidatedOutcome"
                        class="tablePower tablePower-hover table-romeflex"
                      >
                        <template #cell(index)="resultVo">
                          {{ resultVo.item.index }}
                        </template>
                        <template #cell(marketPUp)="resultVo">
                          {{
                            resultVo.item.marketPUp
                              ? Math.round(resultVo.item.marketPUp) / 1000
                              : resultVo.item.marketPUp
                          }}
                        </template>
                        <template #cell(marketPDown)="resultVo">
                          {{
                            resultVo.item.marketPDown
                              ? Math.round(resultVo.item.marketPDown) / 1000
                              : resultVo.item.marketPDown
                          }}
                        </template>
                        <template #cell(marketQUp)="resultVo">
                          {{
                            resultVo.item.marketQUp
                              ? Math.round(resultVo.item.marketQUp) / 1000
                              : resultVo.item.marketQUp
                          }}
                        </template>
                        <template #cell(marketQDown)="resultVo">
                          {{
                            resultVo.item.marketQDown
                              ? Math.round(resultVo.item.marketQDown) / 1000
                              : resultVo.item.marketQDown
                          }}
                        </template>
                        <template #cell(marketPPrice)="resultVo">
                          {{
                            resultVo.item.marketPPrice
                              ? Math.round(resultVo.item.marketPPrice) /
                                100 /
                                0.25 /
                                1000
                              : resultVo.item.marketPPrice
                          }}
                        </template>
                        <template #cell(marketQPrice)="resultVo">
                          {{
                            resultVo.item.marketQPrice
                              ? Math.round(resultVo.item.marketQPrice) /
                                100 /
                                0.25 /
                                1000
                              : resultVo.item.marketQPrice
                          }}
                        </template>
                        <template #cell(productCodeP)="resultVo">
                          {{ resultVo.item.productCodeP }}
                        </template>
                        <template #cell(productCodeQ)="resultVo">
                          {{ resultVo.item.productCodeQ }}
                        </template>
                      </b-table>
                    </b-col>
                  </b-row>
                </b-card>
              </b-card>
            </b-list-group-item>
          </b-list-group>
        </template>
      </b-tab>
    </b-tabs>
  </b-container>
</template>

<script>
import FlexibilityServicesService from "@/services/FlexibilityServicesService"
import MarketOutcomesServices from "@/services/MarketOutcomesServices"
import TechnicalOutcomesService from "@/services/TechnicalOutcomesService"
import ValidatedOutcomesService from "@/services/ValidatedOutcomesService"
import * as XLSX from "xlsx"
import PodsService from "@/services/PodsService"
import DsoRequestForm from "./DsoRequestForm.vue"
import PerimeterForm from "./PerimeterForm.vue"

export default {
  components: {
    DsoRequestForm,
    PerimeterForm
  },

  data () {
    return {
      ...this.$data,
      isSubmitting: false,
      editingData: null,
      isEditing: false,
      marketType: this.formatMarketType(
        this.$route.params.marketType || "dayAhead"
      ),
      startActivation: "",
      manuallyAddedPerimetersCount: 0,
      flexibilityServices: [],
      bspOffers: [],
      dsoRequests: [],
      marketOutcome: [],
      technicalOutcome: [],
      validatedOutcome: [],
      settlement: [],
      fieldsBspOffer: [
        { key: "offerDateTime", label: "Offer Data Time", sortable: true },
        { key: "playerId", label: "Market Operator", sortable: true },
        { key: "offerId", label: "Offer Id", sortable: true },
        { key: "sessionType", label: "Market Type", sortable: true },
        {
          key: 'workflowStatus',
          label: 'GME Sending status',
          sortable: false
        },
        { key: "power", label: "Power" }

      ],
      fieldsDsoRequest: [
        { key: "requestDateTime", label: "Request Data Time", sortable: true },
        { key: "playerId", label: "Market Operator", sortable: true },
        { key: "requestId", label: "Request Id", sortable: true },
        { key: "sessionType", label: "Market Type", sortable: true },
        {
          key: 'workflowStatus',
          label: 'GME/BSP Sending status',
          sortable: false
        },
        { key: "flexibility", label: "Flexibility" }
      ],
      fieldsPower: [
        { key: "index", label: "Index" },
        { key: "pUp", label: "pUp (kW)" },
        { key: "pUpPrice", label: "pUpPrice (€/kWh)" },
        { key: "pDown", label: "pDown (kW)" },
        { key: "pDownPrice", label: "pDownPrice (€/kWh)" }
      ],
      fieldsPowerDsoRequest: [
        { key: "index", label: "Index" },
        { key: "pUp", label: "pUp (kW)" },
        { key: "pDown", label: "pDown (kW)" },
        { key: "pUpPrice", label: "pUpPrice (€/kWh)" },
        { key: "pDownPrice", label: "pDownPrice (€/kWh)" },
        { key: "qUp", label: "qUp (kVAr)" },
        { key: "qDown", label: "qDown (kVAr)" },
        { key: "qUpPrice", label: "qUpPrice (€/kVArh)" },
        { key: "qDownPrice", label: "qDownPrice (€/kVArh)" }
      ],
      fieldsPodRequestList: [
        { key: "pod", label: "Pod" },
        { key: "baselineId", label: "baselineId" }
      ],
      fieldsMarketOutcome: [
        { key: "index", label: "Index" },
        { key: "priorityP", label: "priorityP" }
      ],
      fieldsTechinicalOutcome: [
        { key: "index", label: "Index" },
        { key: "pUpMax", label: "pUpMax (kW)" },
        { key: "pDownMax", label: "pDownMax (kW)" },
        { key: "qUpMax", label: "qUpMax (kW)" },
        { key: "qDownMax", label: "qDownMax (kW)" }
      ],
      fieldsValidatedOutcome: [
        { key: "index", label: "Index" },
        { key: "marketPUp", label: "marketPUp (kW)" },
        { key: "marketPDown", label: "marketPDown (kW)" },
        { key: "marketQUp", label: "marketQUp (kVAr)" },
        { key: "marketQDown", label: "marketQDown (kVAr)" },
        { key: "marketPPrice", label: "marketPPrice (€/kWh)" },
        { key: "marketQPrice", label: "marketQPrice (€/kVArh)" },
        { key: "productCodeP", label: "productCodeP" },
        { key: "productCodeQ", label: "productCodeQ" }
      ],
      filter: null,
      options: {
        format: "YYYY-MM-DD hh:mm:ss",
        useCurrent: false,
        minuteStep: Number(15)
      },
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      availablePods: [],
      usedPods: new Set(),
      editingPerimeters: [],
      visible: false,
      perimetersSelectedPods: new Map(),
      selectedPodsByPerimeter: {},
      globalSelectedPods: new Set()
    }
  },

  created () {
    this.initializeStartActivation()
  },

  computed: {
    allSelectedPods: {
      // Metodo get che restituisce l'insieme dei pod selezionati
      get () {
        return new Set(
          this.editingPerimeters.reduce((pods, _, index) => {
            const formRef = this.$refs[`perimeterForm-${index}`]

            if (formRef && formRef[0]) {
              return [
                ...pods,
                ...formRef[0].form.podRequestList.map((p) => p.pod)
              ]
            }

            return pods
          }, [])
        )
      },
      set (newValue) {}
    }
  },
  watch: {
    "$route.params.marketType": {
      handler (newVal) {
        this.marketType = newVal || "dayAhead"
      },
      immediate: true
    },
    "$route.params.startActivation": {
      handler (newVal) {
        this.updateStartActivation(newVal)
      },
      immediate: true
    }
  },

  async mounted () {
    await this.getFlexibilityServices()
    await this.getMarketOutcome()
    await this.getTechnicalOutcome()
    await this.getValidatedOutcome()
    await this.getFlexibilityServices()
    await this.loadAvailablePods()
  },

  methods: {
    editPerimeter (dsoRequest, perimeter) {
      this.editingData = {
        dsoRequest,
        perimeter
      }
      this.isEditing = true
      this.$bvModal.show("modal-add-perimeter")
    },
    async removePerimeterFromRequest (dsoRequest, perimeter) {
      try {
        if (!await this.$bvModal.msgBoxConfirm('Are you sure you want to remove this perimeter?')) {
          return
        }

        const updatedDsoRequest = {
          ...dsoRequest,
          flexibility: dsoRequest.flexibility.filter(flex => flex.serviceId !== perimeter.serviceId),
          userName: this.$session.get("user").username,
          modificationDateTime: new Date().toISOString()
        }

        await FlexibilityServicesService.updateDsoRequest(updatedDsoRequest)

        await this.getFlexibilityServices()
        this.updateUsedPods()
        await this.loadAvailablePods()

        this.$bvToast.toast('Perimeter removed successfully', {
          title: 'Success',
          variant: 'success'
        })
      } catch (error) {
        console.error('Error removing perimeter:', error)
        this.$bvToast.toast(error.message || 'Error removing perimeter', {
          title: 'Error',
          variant: 'danger'
        })
      }
    },
    async getFlexibilityServices () {
      const response = await FlexibilityServicesService.getByMarketSessions(
        this.$route.params.sessionId
      )
      console.log("Response getBspOffers" + JSON.stringify(response.bspOffer))
      console.log(
        "Response getDsoRequests" + JSON.stringify(response.dsoRequest)
      )
      this.bspOffers = response.bspOffer
      this.dsoRequests = response.dsoRequest
      this.totalRows = this.bspOffers.length + this.dsoRequests.length
    },
    async getMarketOutcome () {
      const response = await MarketOutcomesServices.getByMarketSessions(
        this.$route.params.sessionId
      )
      console.log("Response getMarketOutcome" + JSON.stringify(response.data))
      this.marketOutcome = response.data
    },
    async getTechnicalOutcome () {
      const response = await TechnicalOutcomesService.getByMarketSessions(
        this.$route.params.sessionId
      )
      console.log(
        "Response getTechnicalOutcome" + JSON.stringify(response.data)
      )
      this.technicalOutcome = response.data
    },
    async getValidatedOutcome () {
      const response = await ValidatedOutcomesService.getByMarketSessions(
        this.$route.params.sessionId
      )
      console.log(
        "Response getValidatedOutcome" + JSON.stringify(response.data)
      )
      this.validatedOutcome = response.data
    },
    onFiltered (filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    async exportToVoExcel (flexibilities, marketType, startTime) {
      let podsSheet
      const wb = XLSX.utils.book_new()

      for (let i = 0; i < flexibilities.length; i++) {
        const power = flexibilities[i].power
        let arrayFlex = []
        for (let j = 0; j < power.length; j++) {
          const powerObj = {
            index: power[j].index,
            acceptedPValue: power[j].acceptedPValue,
            acceptedQValue: power[j].acceptedQValue,
            acceptedPPrice: power[j].acceptedPPrice,
            acceptedQPrice: power[j].acceptedQPrice,
            acceptedPtype: power[j].acceptedPtype,
            rejectionTypeP: power[j].rejectionTypeP,
            rejectionTypeQ: power[j].rejectionTypeQ,
            playerServiceId: power[j].playerServiceId,
            playerRequestId: power[j].playerRequestId,
            playerOfferId: power[j].playerOfferId
          }
          arrayFlex.push(powerObj)
        }

        podsSheet = XLSX.utils.json_to_sheet(arrayFlex)
        XLSX.utils.book_append_sheet(
          wb,
          podsSheet,
          "POD - " + flexibilities[i].pod
        )
      }
      XLSX.writeFile(
        wb,
        "validateOutcome" + "_" + marketType + "_" + startTime + ".xlsx"
      )
    },
    async exportToFsExcel (result, serviceType) {
      let podsSheet
      const wb = XLSX.utils.book_new()
      const flexibilities = result.flexibility
      let pod
      let podName

      for (let i = 0; i < flexibilities.length; i++) {
        const power = flexibilities[i].power
        podName = flexibilities[i].pod
        let arrayFlex = []
        for (let j = 0; j < power.length; j++) {
          const powerObj = {
            index: power[j].index,
            p: power[j].p,
            pPrice: power[j].pPrice,
            q: power[j].q,
            qPrice: power[j].qPrice
          }
          arrayFlex.push(powerObj)
        }

        podsSheet = XLSX.utils.json_to_sheet(arrayFlex)
        if (serviceType === "DSO_request") {
          const length = 28
          pod = podName.toString().substring(0, length) + "..."
          podName = ""
        }
        XLSX.utils.book_append_sheet(wb, podsSheet, pod)
      }
      XLSX.writeFile(
        wb,
        "flexibilityService" + "_" + result.playerServiceId + ".xlsx"
      )
    },
    async exportToMoExcel (flexibilities, marketType, startTime) {
      let podsSheet
      const wb = XLSX.utils.book_new()

      for (let i = 0; i < flexibilities.length; i++) {
        const power = flexibilities[i].power
        let arrayFlex = []
        for (let j = 0; j < power.length; j++) {
          const powerObj = {
            index: power[j].index,
            p: power[j].p,
            priorityP: power[j].priorityP,
            q: power[j].q,
            priorityQ: power[j].priorityQ
          }
          arrayFlex.push(powerObj)
        }

        podsSheet = XLSX.utils.json_to_sheet(arrayFlex)
        XLSX.utils.book_append_sheet(
          wb,
          podsSheet,
          "POD - " + flexibilities[i].pod
        )
      }
      XLSX.writeFile(
        wb,
        "marketOutcome" + "_" + marketType + "_" + startTime + ".xlsx"
      )
    },
    async exportToToExcel (flexibilities, marketType, startTime) {
      let podsSheet
      const wb = XLSX.utils.book_new()

      for (let i = 0; i < flexibilities.length; i++) {
        const power = flexibilities[i].power
        let arrayFlex = []
        for (let j = 0; j < power.length; j++) {
          const powerObj = {
            index: power[j].index,
            acceptedPValue: power[j].acceptedPValue,
            acceptedQValue: power[j].acceptedQValue,
            acceptedP: power[j].acceptedP,
            acceptedQ: power[j].acceptedQ
          }
          arrayFlex.push(powerObj)
        }

        podsSheet = XLSX.utils.json_to_sheet(arrayFlex)
        XLSX.utils.book_append_sheet(
          wb,
          podsSheet,
          "POD - " + flexibilities[i].pod
        )
      }
      XLSX.writeFile(
        wb,
        "technicalOutcome" + "_" + marketType + "_" + startTime + ".xlsx"
      )
    },
    async exportToSetExcel (flexibilities, marketType, startTime) {
      let podsSheet
      const wb = XLSX.utils.book_new()

      for (let i = 0; i < flexibilities.length; i++) {
        const power = flexibilities[i].power
        let arrayFlex = []
        for (let j = 0; j < power.length; j++) {
          const powerObj = {
            index: power[j].index,
            requestedP: power[j].requestedP,
            paidP: power[j].paidP,
            measuredQ: power[j].measuredQ,
            paidQ: power[j].paidQ,
            requestPlayerId: power[j].requestPlayerId,
            offerPlayerId: power[j].offerPlayerId
          }
          arrayFlex.push(powerObj)
        }

        podsSheet = XLSX.utils.json_to_sheet(arrayFlex)
        XLSX.utils.book_append_sheet(
          wb,
          podsSheet,
          "POD - " + flexibilities[i].pod
        )
      }
      XLSX.writeFile(
        wb,
        "settlement" + "_" + marketType + "_" + startTime + ".xlsx"
      )
    },

    async loadAvailablePods (currentPerimeterIndex) {
      try {
        const response = await PodsService.getPods()

        // Raccogli tutti i pod già utilizzati nella dsoRequest corrente
        const existingPods = new Set()
        this.dsoRequests.forEach((request) => {
          request.flexibility.forEach((flex) => {
            flex.podRequestList.forEach((pod) => {
              existingPods.add(pod.pod)
            })
          })
        })

        // Raccogli i pod selezionati in altri perimetri
        const podsSelectedInOtherPerimeters = new Set()
        Object.entries(this.selectedPodsByPerimeter).forEach(
          ([index, pods]) => {
            if (parseInt(index) !== currentPerimeterIndex) {
              pods.forEach((pod) => podsSelectedInOtherPerimeters.add(pod))
            }
          }
        )

        // Filtra i pod disponibili
        this.availablePods = response.data
          .filter((pod) => pod.rdActivationStatus === "enabled")
          .filter((pod) => pod.baselineId && pod.baselineId.trim() !== "")
          .filter((pod) => !existingPods.has(pod.pod)) // Rimuovi i pod già nella dsoRequest
          .filter((pod) => !podsSelectedInOtherPerimeters.has(pod.pod))
          .map((pod) => ({
            value: pod.pod,
            pod: pod.pod,
            baselineId: pod.baselineId,
            aggregatorId: pod.aggregatorId,
            rdActivationStatus: pod.rdActivationStatus,
            upperP: pod.upperP / 1000,
            upperQ: pod.upperQ / 1000
          }))

        console.log("Existing pods:", existingPods)
        console.log(
          "Available pods after filtering:",
          this.availablePods.map((p) => p.pod)
        )
      } catch (error) {
        console.error("Error loading pods:", error)
        this.$bvToast.toast("Error loading available pods", {
          title: "Error",
          variant: "danger"
        })
      }
    },

    updateAvailablePods (selectedPods, perimeterIndex) {
      // Aggiorna la lista dei pod disponibili
      this.loadAvailablePods()
    },

    updateUsedPods () {
      this.usedPods.clear()
      this.dsoRequests.forEach((request) => {
        request.flexibility.forEach((flex) => {
          flex.podRequestList.forEach((pod) => {
            this.usedPods.add(pod.pod)
          })
        })
      })
    },

    showNewDsoRequestDialog () {
      this.$bvModal.show("modal-new-dso-request")
    },

    showAddPerimeterDialog () {
      this.isEditing = false
      this.editingData = null
      this.editingPerimeters = []
      this.$bvModal.show("modal-add-perimeter")
    },

    async handleNewDsoRequestSubmit () {
      if (this.isSubmitting) return

      this.isSubmitting = true

      try {
        if (!this.$refs.dsoRequestForm) {
          throw new Error("Form not found")
        }

        const requestData = this.$refs.dsoRequestForm.getFormData()

        const enrichedRequestData = {
          ...requestData,
          userName: this.$session.get("user").username,
          modificationDateTime: new Date().toISOString()
        }

        await FlexibilityServicesService.saveDsoRequest(enrichedRequestData)

        this.$bvModal.hide("modal-new-dso-request")

        // Aggiorna i dati
        await this.getFlexibilityServices()
        this.updateUsedPods()
        await this.loadAvailablePods()

        this.$bvToast.toast("DSO Request created successfully", {
          title: "Success",
          variant: "success"
        })
      } catch (error) {
        console.error("Error creating DSO request:", error)
        this.$bvToast.toast(error.message || "Error creating DSO request", {
          title: "Error",
          variant: "danger"
        })
      } finally {
        this.isSubmitting = false
      }
    },

    getEditFormRef () {
      const formRef = this.$refs.editForm
      console.log("Edit form ref:", formRef)
      if (!formRef) {
        console.error("Form ref is undefined")
        return null
      }
      if (Array.isArray(formRef)) {
        return formRef[0]
      }
      return formRef
    },

    async handleSavePerimeter (bvModalEvent) {
      bvModalEvent.preventDefault()

      try {
        if (this.isEditing) {
          console.log("Editing mode active, getting form ref...")
          const formRef = this.getEditFormRef()

          if (!formRef) {
            console.error("Form reference is null")
            throw new Error("Form di modifica non trovato")
          }

          console.log("Got form ref, getting form data...")
          const formData = formRef.getFormData()
          console.log("Form data:", formData)

          const updatedDsoRequest = {
            ...this.editingData.dsoRequest,
            userName: this.$session.get("user").username,
            flexibility: this.editingData.dsoRequest.flexibility.map((flex) => {
              if (flex.serviceId === this.editingData.perimeter.serviceId) {
                return {
                  ...formData,
                  isMip: true,
                  marketOutcomeId: "idContract",
                  reducedQuantity: false,
                  serviceId: flex.serviceId,
                  podRequestList: formData.podRequestList.map((pod) => ({
                    pod: pod.pod,
                    baselineId: pod.baselineId,
                    productReferenceList: formData.power.map((p) => ({
                      index: p.index,
                      productCodeP: "defaultContract",
                      productCodeQ: "defaultContract"
                    }))
                  }))
                }
              }
              return flex
            })
          }

          try {
            await FlexibilityServicesService.updateDsoRequest(
              updatedDsoRequest
            )
            this.$bvToast.toast("Perimetro aggiornato con successo", {
              title: "Successo",
              variant: "success"
            })
          } catch (error) {
            console.error("Error updating DSO request:", error)

            if (error.response) {
              const status = error.response.status
              if (status === 400 || status === 404) {
                const errorMessage = error.response.data.message || 'Errore durante l\'operazione'
                this.$bvToast.toast(errorMessage, {
                  title: "Errore",
                  variant: "danger"
                })
              } else if (status === 500) {
                this.$bvToast.toast("Si è verificato un errore interno del server", {
                  title: "Errore",
                  variant: "danger"
                })
              }
            }
          }
        } else {
          const perimetersData = await Promise.all(
            this.editingPerimeters.map(async (_, index) => {
              const formRef = this.$refs[`perimeterForm-${index}`]
              if (!formRef || !formRef[0]) {
                throw new Error(`Form del perimetro ${index + 1} non trovato`)
              }
              const formData = formRef[0].getFormData()
              return {
                ...formData,
                isMip: true,
                marketOutcomeId: "idContract",
                reducedQuantity: false,
                podRequestList: formData.podRequestList.map((pod) => ({
                  pod: pod.pod,
                  baselineId: pod.baselineId,
                  productReferenceList: formData.power.map((p) => ({
                    index: p.index,
                    productCodeP: "defaultContract",
                    productCodeQ: "defaultContract"
                  }))
                }))
              }
            })
          )

          const existingDsoRequest = this.dsoRequests[0]
          const requestData = {
            ...existingDsoRequest,
            userName: this.$session.get("user").username,
            flexibility: [...existingDsoRequest.flexibility, ...perimetersData]
          }

          try {
            await FlexibilityServicesService.updateDsoRequest(requestData)
            this.$bvToast.toast("New perimeter added successfully", {
              title: "Success",
              variant: "success"
            })
          } catch (error) {
            console.error("Error creating DSO request:", error)

            if (error.response) {
              const status = error.response.status
              if (status === 400 || status === 404) {
                const errorMessage = error.response.data.message || 'Errore durante l\'operazione'
                this.$bvToast.toast(errorMessage, {
                  title: "Errore",
                  variant: "danger"
                })
              } else if (status === 500) {
                this.$bvToast.toast("Si è verificato un errore interno del server", {
                  title: "Errore",
                  variant: "danger"
                })
              }
            }
          }
        }

        this.$bvModal.hide("modal-add-perimeter")
        await this.getFlexibilityServices()
        this.updateUsedPods()
        await this.loadAvailablePods()

        this.isEditing = false
        this.editingData = null
        this.editingPerimeters = []
      } catch (error) {
        console.error("Error in handleSavePerimeter:", error)
        this.$bvToast.toast(error.message || "Errore durante il salvataggio", {
          title: "Errore",
          variant: "danger"
        })
      }
    },
    getNextPerimeterIndex () {
      console.log("DSO Requests:", this.dsoRequests)

      const existingServiceIds = this.dsoRequests
        .flatMap((request) => request.flexibility || [])
        .map((flex) => flex.serviceId)
        .filter((id) => id.includes("-M"))
        .map((id) => {
          const numStr = id.split("-M")[1]
          console.log("Extracted number from existing:", numStr)
          return parseInt(numStr)
        })

      console.log("Existing Service IDs:", existingServiceIds)

      const dialogServiceIds = this.editingPerimeters
        .map((perimeter) => perimeter.serviceId)
        .filter((id) => id.includes("-M"))
        .map((id) => {
          const numStr = id.split("-M")[1]
          console.log("Extracted number from dialog:", numStr)
          return parseInt(numStr)
        })

      console.log("Dialog Service IDs:", dialogServiceIds)

      const allIndices = [...existingServiceIds, ...dialogServiceIds]
      console.log("All indices:", allIndices)

      const validIndices = allIndices.filter(
        (index) => Number.isFinite(index) && !Number.isNaN(index)
      )

      if (validIndices.length === 0) {
        return 1
      }

      return Math.max(...validIndices) + 1
    },

    generateServiceId () {
      const date = new Date(this.startActivation)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, "0")
      const day = String(date.getDate()).padStart(2, "0")
      const formattedDate = `${year}-${month}-${day}`
      const marketType = this.marketType
        .toUpperCase()
        .replace("AHEAD", "_AHEAD")
      const nextIndex = this.getNextPerimeterIndex()
      return `${formattedDate}T00:00-${marketType}-M${nextIndex}`
    },

    addNewPerimeter () {
      const serviceId = this.generateServiceId()
      this.editingPerimeters.push({ serviceId })
      this.loadAvailablePods()
    },

    removePerimeter (index) {
      this.editingPerimeters.splice(index, 1)
      this.loadAvailablePods()
    },
    handlePodSelection (pod, perimeterIndex, isSelected) {
      if (isSelected) {
        this.globalSelectedPods.set(pod.pod, perimeterIndex)
      } else {
        this.globalSelectedPods.delete(pod.pod)
      }

      // Aggiorna tutti i perimetri
      this.editingPerimeters.forEach((_, index) => {
        const formRef = this.$refs[`perimeterForm-${index}`][0]
        if (formRef) {
          const availablePods = this.availablePods.filter((p) => {
            const currentOwner = this.globalSelectedPods.get(p.pod)
            return !currentOwner || currentOwner === index
          })
          formRef.updatePods(availablePods)
        }
      })
    },
    handlePodPermanentSelection (podId) {
      this.availablePods = this.availablePods.filter(
        (pod) => pod.pod !== podId
      )
    },
    handlePodRestored (pod) {
      // Aggiungi il pod alla lista disponibile
      this.availablePods.push(pod)
      this.availablePods.sort((a, b) => a.pod.localeCompare(b.pod))
    },
    resetNewDsoRequestForm () {
      if (this.$refs.dsoRequestForm) {
        this.$refs.dsoRequestForm.resetForm()
      }
      if (this.$refs.initialPerimeterForm) {
        this.$refs.initialPerimeterForm.resetForm()
      }
      this.activeTab = 0
      this.isBaseRequestValid = false
      this.initialPerimeterId = null
      this.newDsoRequest = null
    },

    resetPerimeterForm () {
      this.editingPerimeters = []
      this.isEditing = false
      this.editingData = null
    },
    calculateExistingPerimetersCount () {
      return this.manuallyAddedPerimetersCount
    },

    initializeStartActivation () {
      const startActivation = this.$route.params.startActivation
      this.updateStartActivation(startActivation)
    },

    updateStartActivation (value) {
      if (!value) {
        const now = new Date()
        const year = now.getFullYear()
        const month = String(now.getMonth() + 1).padStart(2, "0")
        const day = String(now.getDate()).padStart(2, "0")
        this.startActivation = `${year}-${month}-${day}T00:00`
      } else {
        this.startActivation = value
      }
      console.log("Updated startActivation:", this.startActivation)
    },
    formatMarketType (type) {
      switch (type.toLowerCase()) {
        case "dayahead":
          return "DAY_AHEAD"
        case "realtime":
          return "REAL_TIME"
        default:
          return "DAY_AHEAD"
      }
    },
    onToggle (visible) {
      this.visible = visible
    },
    handlePodToggle ({ pod, isSelected, perimeterIndex }) {
      console.log(
        "Pod toggled:",
        pod.pod,
        "Selected:",
        isSelected,
        "Perimeter:",
        perimeterIndex
      )

      if (!this.selectedPodsByPerimeter[perimeterIndex]) {
        this.selectedPodsByPerimeter[perimeterIndex] = []
      }

      if (isSelected) {
        this.selectedPodsByPerimeter[perimeterIndex].push(pod.pod)
        this.globalSelectedPods.add(pod.pod)
      } else {
        this.selectedPodsByPerimeter[perimeterIndex] =
          this.selectedPodsByPerimeter[perimeterIndex].filter(
            (p) => p !== pod.pod
          )
        this.globalSelectedPods.delete(pod.pod)
      }
      this.editingPerimeters.forEach((_, index) => {
        const formRef =
          this.$refs[`perimeterForm-${index}`] &&
          this.$refs[`perimeterForm-${index}`][0]
        if (formRef && formRef.podSelector) {
          if (index === perimeterIndex) {
            const currentPerimeterPods = this.availablePods
            formRef.podSelector.updateAvailablePods(currentPerimeterPods)
          } else {
            const filteredPods = this.availablePods.filter(
              (p) =>
                !this.selectedPodsByPerimeter[perimeterIndex] ||
                !this.selectedPodsByPerimeter[perimeterIndex].includes(p.pod)
            )
            formRef.podSelector.updateAvailablePods(filteredPods)
          }
        }
      })

      console.log("Selected pods by perimeter:", this.selectedPodsByPerimeter)
      console.log("Global selected pods:", this.globalSelectedPods)
    },
    handlePerimeterPodSelection (perimeterIndex, selectedPods) {
      // Aggiorna il perimetro corrente
      this.selectedPodsByPerimeter[perimeterIndex] = new Set(
        selectedPods.map((p) => p.pod)
      )
      console.log(
        "selectedPodsByPerimeter >> " +
          JSON.stringify(this.selectedPodsByPerimeter[perimeterIndex])
      )
      this.editingPerimeters.forEach((_, index) => {
        const formRef =
          this.$refs[`perimeterForm-${index}`] &&
          this.$refs[`perimeterForm-${index}`][0]
        if (formRef && formRef.podSelector) {
          const podsForThisPerimeter = this.availablePods.filter((pod) => {
            if (
              this.selectedPodsByPerimeter[index] &&
              this.selectedPodsByPerimeter[index].has(pod.pod)
            ) {
              return true
            }
            return !Object.entries(this.selectedPodsByPerimeter)
              .filter(([idx]) => idx !== index.toString())
              .some(([_, pods]) => pods.has(pod.pod))
          })

          formRef.podSelector.updateAvailablePods(podsForThisPerimeter)
        }
      })
    },

    getPodsAvailableForPerimeter (perimeterIndex) {
      const otherSelectedPods = new Set()
      this.perimetersSelectedPods.forEach((pods, index) => {
        if (index !== perimeterIndex) {
          pods.forEach((pod) => otherSelectedPods.add(pod))
        }
      })
      return this.availablePods.filter(
        (pod) => !otherSelectedPods.has(pod.pod)
      )
    }
  }
}
</script>

<style>
.table-romeflex thead {
  background-color: #af0f6a;
  color: white;
}
.ecube-button {
  margin-bottom: 10px;
}
.collapsed > .when-opened,
:not(.collapsed) > .when-closed {
  display: none;
}
.consumers button {
  width: 140px;
  margin-bottom: 10px;
}
.tablePower thead {
  background-color: #af0f6a;
  color: white;
}
.tablePower-hover thead tr th:hover,
.tablePower-hover thead tr:hover th,
.tablePower-hover thead tr:hover td,
.tablePower-hover thead tr td:hover {
  color: white !important;
}
.flex-card {
  margin-top: 20px;
}
.xlsx-button {
  margin-bottom: 20px;
  background-color: #af0f6a;
}
.custom-button {
  background-color: #af0f6a !important;
  border-color: #af0f6a !important;
  color: white !important;
}

.custom-button:hover,
.custom-button:focus,
.custom-button:active {
  background-color: #925277 !important;
  border-color: #925277 !important;
}
#modal-add-perimeter .modal-dialog {
  max-width: 95vw !important;
  width: 80% !important;
}

#modal-add-perimeter .modal-content {
  width: 100% !important;
}

.fa-chevron-up,
.fa-chevron-down {
  transition: transform 0.3s;
}
</style>



// WEBPACK FOOTER //
// src/components/FlexibilityServices.vue